<template>
  <div>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Type
            </th>
            <th class="text-left">
              Document
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in documents" :key="item.uuid">
            <td v-if="item.role">{{ item.role.name }}</td>
            <td>{{ item.comments }}</td>
            <td>
              <a :href="item.path" target="_blank" v-if="item.type !== 'pdf'"
                ><img :src="item.path" width="200"
              /></a>
              <a v-else :href="item.path" target="_blank"> PDF</a>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: "documentsList",

  props: ["documents"],
  components: {},

  data: () => ({
    loading: false,
  }),

  methods: {
    submit() {
      this.loading = true;
    },
    deleteDocument(id) {
      this.$emit("deleteDocument", id);
    },
  },
};
</script>
